import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { Button, Grid, Box, Typography } from '@mui/material';
import { gridSpacing } from 'store/constant';
import { useApi } from 'Service/axios';
import { TableBox } from './style';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';
import formater from 'utils/DateDDMMYYY';
import ActionButton from './components/ActionButton';

const Separacao = () => {
    // ============================= INSTÂNCIAS =============================
    const api = useApi();
    const navigate = useNavigate();
    // ============================= STATES =============================
    const [allSolicitacao, setAllSolicitacao] = useState([]);

    const columns = [
        { field: 'id', headerName: 'ID', flex: 0.5 },
        {
            field: 'data',
            headerName: 'DATA',
            flex: 0.8,
            valueGetter: (params) => formater(params?.row?.data)
        },
        {
            field: 'necessidade',
            headerName: 'NECESSIDADE',
            flex: 1,
            sortable: false,
            valueGetter: (params) => formater(params?.row?.necessidade)
        },
        {
            field: 'obra',
            headerName: 'OBRA',
            flex: 1,
            valueGetter: (params) => params?.row?.obra?.descricao
        },
        {
            field: 'projeto',
            headerName: 'PROJETO',
            flex: 1,
            valueGetter: (params) => params?.row?.projeto?.descricao
        },
        { field: 'status_separacao', headerName: 'STATUS SEP', flex: 1 },
        {
            field: 'acao',
            headerName: 'AÇÕES',
            flex: 0.7,
            sortable: false,
            renderCell: (params) => <ActionButton row={params.row} getSolicitacoes={getSolicitacoes} />
        }
    ];
    // ============================= FUNÇÕES =============================

    const handleSelectionModelChange = (newSelection) => {
        setSelectedItems(newSelection);
    };

    const getSolicitacoes = async () => {
        try {
            const response = await api.getAllSolicitacao();
            setAllSolicitacao(response.data.solicitacoes);
        } catch (error) {
            toast.error(error.response.data.mensagem);
        }
    };

    useEffect(() => {
        getSolicitacoes();
    }, []);

    return (
        <MainCard>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '2em'
                }}
            >
                <Typography sx={{ fontSize: '1.125rem', fontWeight: '500' }}>Separação</Typography>
            </Box>
            <Grid container spacing={gridSpacing}>
                <TableBox>
                    <DataGrid
                        rows={allSolicitacao}
                        columns={columns}
                        hideFooter={true}
                        onSelectionModelChange={() => handleSelectionModelChange(params.id)}
                    />
                </TableBox>
            </Grid>
        </MainCard>
    );
};

export default Separacao;
